import React from "react";
import ReactDOM from "react-dom";

import { getBootstrapInfo } from "routers/shared/util/WebUtil";
import { initializeGlobals } from "routers/shared/util/helpers";

// Import the right SPA for the platform.
const SpaRouter = process.env.PLATFORM === "desktop"
	? require("./Desktop").default
	: require("./MobileWeb").default;

getBootstrapInfo()
	.then(initializeGlobals)
	.then((globals) => {
		ReactDOM.render(
			<SpaRouter
				{...globals}
			/>,
			document.getElementById("root"),
		);
	});



// WEBPACK FOOTER //
// ./src/routers/index.js